import ConfigurationList from '@/pages/routing/ConfigurationList.vue'
import FormatList from '@/pages/routing/FormatList.vue'
import InterProcessConfigurationDetails from '@/pages/routing/InterProcessConfigurationDetails.vue'
import MessageList from '@/pages/routing/MessageList.vue'
import MessageDetails from '@/pages/routing/MessageDetails.vue'
import MQSeriesConfigurationDetails from '@/pages/routing/MQSeriesConfigurationDetails.vue'
import RemoteFolderConfigurationDetails from '@/pages/routing/RemoteFolderConfigurationDetails.vue'
import WebServiceConfigurationDetails from '@/pages/routing/WebServiceConfigurationDetails.vue'
import InterProcessConfigurationPage from '@/pages/routing/InterProcessConfigurationPage.vue'
import MQSeriesConfigurationPage from '@/pages/routing/MQSeriesConfigurationPage.vue'
import RemoteFolderConfigurationPage from '@/pages/routing/RemoteFolderConfigurationPage.vue'
import WebServiceCredentialDetails from "@/pages/routing/WebServiceCredentialDetails.vue";
import MQSeriesCredentialDetails from "@/pages/routing/MQSeriesCredentialDetails.vue";
import FTPCredentialDetails from "@/pages/routing/FTPCredentialDetails.vue";
import FTPConfigurationDetails from "@/pages/routing/FTPConfigurationDetails.vue";
import MQSeriesList from "@/pages/routing/MQSeriesList.vue";
import MessageFileForm from "@/pages/routing/MessageFileForm.vue";
import ConfigurationS3 from "@/pages/routing/ConfigurationS3.vue";
import S3ConfigurationDetails from "@/pages/routing/S3ConfigurationDetails.vue";

export default [
  {
    path: '/routing/configurationList/:type/:role',
    component: ConfigurationList,
    props: true
  },
  {
    path: '/routing/formatList',
    component: FormatList,
    props: true
  },
  {
    path: '/routing/interProcessConfigurationDetails/:mode',
    component: InterProcessConfigurationDetails,
    props: true
  },
  {
    path: '/routing/interProcessConfig/:id',
    component: InterProcessConfigurationPage,
    props: true
  },
  {
    path: '/routing/configlist/:role/:type/:entitiesType/',
    component: ConfigurationList,
    props: true
  },
  {
    path: '/routing/configS3/:s3/:mode',
    component: WebServiceCredentialDetails,
    props: true
  },
  {
    path: '/routing/credentialTB/:tb/:mode',
    component: WebServiceCredentialDetails,
    props: true
  },
  {
    path: '/routing/configTB/:tb/:mode',
    component: WebServiceConfigurationDetails,
    props: true
  },
  {
    path: '/routing/configS3list/:msgType/:entitiesType/',
    component: ConfigurationS3,
    props: true
  },
  {
    path: '/routing/messageDetails/:mode/:role/:type/:entitiesType/:tabName',
    component: MessageDetails,
    props: true
  },
  {
    path: '/routing/messageDetails/import/:entitiesType',
    component: MessageFileForm,
    props: true
  },
  {
    path: '/routing/messageList/:roleFromURL/:typeFromURL',
    component: MessageList
  },
  {
    path: '/routing/mqseriesCredentialDetails/:mode/:entitiesType/:role/:IdConfigRouting',
    component: MQSeriesCredentialDetails,
    props: true
  },
  {
    path: '/routing/mqseriesConfigurationDetails/:mode/:entitiesType/:role/:IdConfigRouting',
    component: MQSeriesConfigurationDetails,
    props: true
  },
  {
    path: '/routing/mqseriesConfig/:id',
    component: MQSeriesConfigurationPage,
    props: true
  },
  {
    path: '/routing/mqseriesListConfig/:role/:entitiesType/:id',
    component: MQSeriesList,
    props: true
  },
  {
    path: '/routing/remoteFolderConfigurationDetails/:mode',
    component: RemoteFolderConfigurationDetails,
    props: true
  },
  {
    path: '/routing/remoteFolderConfig/:id',
    component: RemoteFolderConfigurationPage,
    props: true
  },
  {
    path: '/routing/ftpConfigurationDetails/:mode/:entitiesType',
    component: FTPConfigurationDetails,
    props: true
  },
  {
    path: '/routing/S3ConfigurationDetails/:mode/:msgType/:entitiesType/:IdConfigRouting',
    component: S3ConfigurationDetails,
    props: true
  },
  {
    path: '/routing/ftpCredentialDetails/:mode/:entitiesType',
    component: FTPCredentialDetails,
    props: true
  },
  {
    path: '/routing/webServiceConfigurationDetails/:mode/:entitiesType',
    component: WebServiceConfigurationDetails,
    props: true
  },
  {
    path: '/routing/webServiceCredentialDetails/:mode/:entitiesType',
    component: WebServiceCredentialDetails,
    props: true
  }
]
